<header
  #recordHeader
  class="relative flex h-[60px] flex-[0_0_60px] items-center bg-primary px-5 text-white max-[640px]:sticky max-[640px]:top-0 max-[640px]:z-[2]"
>
  @if (environment?.logoImageNegative) {
    <img
      class="h-5 w-auto"
      alt=""
      [src]="environment.logoImageNegative"
    />
  }

  <h2 class="absolute left-1/2 m-0 -translate-x-1/2 text-[15px] font-bold uppercase leading-normal tracking-[.04em] text-white">
    {{ titleKey | transloco }}
  </h2>

  <button
    type="button"
    class="ml-auto flex h-[30px] w-[30px] items-center justify-center rounded-[6px] text-white hover:bg-white/[.18] focus-visible:outline focus-visible:outline-2 focus-visible:outline-white"
    svcTestId="alert-record-modal__btn--close"
    [attr.aria-label]="'Fechar' | transloco"
    (click)="dialogRef.close()"
  >
    <ng-icon
      name="svcX"
      size="18px"
      aria-hidden="true"
    />
  </button>
</header>

<div class="flex min-h-0 flex-1 flex-col overflow-y-auto overflow-x-hidden p-6 max-[640px]:p-4">
  @if (isSaveLoading) {
    <div class="fadeIn flex-auto flex items-center justify-center py-30">
      <mat-spinner
        class="text-primary"
        diameter="30"
      />
    </div>
  }

  <div
    class="fadeIn flex-auto"
    [hidden]="isSaveLoading || isInitialLoading"
  >
    <div #topInfo>
      @if (!isAddMode) {
        <div class="mb-3">
          <span class="mb-0.5 block text-[11px] leading-[14px] tracking-[-.01em] text-muted-foreground">{{ 'Número' | transloco }}</span>
          <div class="flex flex-wrap items-center gap-2">
            <span
              class="text-base font-bold leading-[1.3] text-[#2a2a2a]"
              svcTestId="alert-record-modal__text--number"
            >
              {{ 'ALE' | transloco }}-{{ formAlert?.controls.alertId.value }}
            </span>
            @if (statePill; as pill) {
              <svz-status-badge
                class="[&>div]:leading-[1.3]"
                variant="pill"
                svcTestId="alert-record-modal__badge--state"
                [truncate]="false"
                [badgeData]="{ description: (pill.label | transloco), type: 'none' }"
                [colorClass]="pill.colorClass"
              />
            }
          </div>
        </div>
      }
    </div>

    <svz-tab-nav
      testIdPrefix="alert-record-modal"
      [items]="recordTabs"
      [activeKey]="activeTabKey"
      [ariaLabel]="titleKey | transloco"
      (onTabSelected)="selectRecordTab($event)"
    />

    <div class="block pt-2">
      <!-- ALERT -->
      <div
        [class.hidden]="tabIndex !== 0"
        #alertTab
      >
        @if (isViewMode) {
          @let view = recordView;
          <div class="mb-[18px] flex flex-wrap items-center gap-3.5 rounded-[8px] bg-primary/[.13] px-4 py-3 text-primary">
            <ng-icon
              name="svcCal"
              size="20px"
              aria-hidden="true"
            />

            <div class="min-w-0 flex-[1_1_160px]">
              <span class="mb-0.5 block text-[11px] leading-[14px] tracking-[-.01em] text-[#2a2a2a]">{{ 'Data de abertura' | transloco }}</span>
              <input
                class="h-11 w-full rounded-[8px] border border-[#e4e7ea] bg-[#f4f5f7] px-3.5 text-sm leading-[normal] text-[#1c1c1c] opacity-45"
                disabled
                svcTestId="alert-record-modal__input--opening-date"
                [attr.aria-label]="'Data de abertura' | transloco"
                [value]="view.openingDate | dateFormat"
              />
            </div>

            <div class="min-w-0 flex-[1_1_160px]">
              <span class="mb-0.5 block text-[11px] leading-[14px] tracking-[-.01em] text-[#2a2a2a]">{{ 'Data de ocorrência' | transloco }}</span>
              <input
                class="h-11 w-full rounded-[8px] border border-[#e4e7ea] bg-[#f4f5f7] px-3.5 text-sm leading-[normal] text-[#1c1c1c] opacity-45"
                disabled
                svcTestId="alert-record-modal__input--occurrence-date"
                [attr.aria-label]="'Data de ocorrência' | transloco"
                [value]="view.occurrenceDate | dateFormat"
              />
            </div>
          </div>

          @if (midiasCarousel?.length) {
            <div class="mx-auto mb-[18px] aspect-[16/10] w-full max-w-[260px] overflow-hidden rounded-[8px] border border-[#f0f2f5] bg-[#EEF1FB]">
              <svz-media-carousel
                class="block h-full"
                fillHeight
                [items]="midiasCarousel"
                [editMode]="false"
                [showEmptyInViewMode]="false"
                [playVideoWhenMouseHover]="false"
              />
            </div>
          } @else {
            <div
              class="mx-auto mb-[18px] flex aspect-[16/10] w-full max-w-[260px] items-center justify-center rounded-[8px] border border-[#f0f2f5] bg-primary/[.06] text-primary/40"
              svcTestId="alert-record-modal__media--empty"
            >
              <ng-icon
                name="svcImage"
                size="20px"
                aria-hidden="true"
              />
            </div>
          }

          <div class="flex flex-col gap-3">
            <div>
              <span class="mb-0.5 block text-[11px] leading-[14px] tracking-[-.01em] text-muted-foreground">{{ 'Originador' | transloco }}</span>
              <span
                class="flex flex-wrap items-center gap-2 text-base font-bold leading-[1.3] text-[#2a2a2a]"
                svcTestId="alert-record-modal__text--originator"
              >
                @if (view.originator) {
                  <svz-user-avatar
                    class="flex-none"
                    [info]="view.originator"
                  />
                  {{ view.originator.name }}
                } @else {
                  -
                }
              </span>
            </div>

            <div>
              <span class="mb-0.5 block text-[11px] leading-[14px] tracking-[-.01em] text-muted-foreground">{{ 'Time' | transloco }}</span>
              <span
                class="block text-base font-bold leading-[1.3] text-[#2a2a2a]"
                svcTestId="alert-record-modal__text--team"
              >
                {{ view.team || '-' }}
              </span>
            </div>

            <div>
              <span class="mb-0.5 block text-[11px] leading-[14px] tracking-[-.01em] text-muted-foreground">{{ 'Local' | transloco }}</span>
              <span
                class="block text-base font-bold leading-[1.3] text-[#2a2a2a]"
                svcTestId="alert-record-modal__text--place"
              >
                {{ view.place || '-' }}
              </span>
            </div>

            <div>
              <span class="mb-0.5 block text-[11px] leading-[14px] tracking-[-.01em] text-muted-foreground">{{ 'Classificação' | transloco }}</span>
              <span
                class="block text-base font-bold leading-[1.3] text-[#2a2a2a]"
                svcTestId="alert-record-modal__text--classification"
              >
                {{ view.classification || '-' }}
              </span>
            </div>

            <div>
              <span class="mb-0.5 block text-[11px] leading-[14px] tracking-[-.01em] text-muted-foreground">{{ 'Falha' | transloco }}</span>
              <span
                class="block text-base font-bold leading-[1.3] text-[#2a2a2a]"
                svcTestId="alert-record-modal__text--failure"
              >
                {{ view.failure || '-' }}
              </span>
            </div>

            <div>
              <span class="mb-0.5 block text-[11px] leading-[14px] tracking-[-.01em] text-muted-foreground">{{ 'Tipo de material' | transloco }}</span>
              <span
                class="block text-base font-bold leading-[1.3] text-[#2a2a2a]"
                svcTestId="alert-record-modal__text--material-type"
              >
                {{ view.materialType || '-' }}
              </span>
            </div>

            <div>
              <span class="mb-0.5 block text-[11px] leading-[14px] tracking-[-.01em] text-muted-foreground">{{ 'Material' | transloco }}</span>
              <span
                class="block text-base font-bold leading-[1.3] text-[#2a2a2a]"
                svcTestId="alert-record-modal__text--material"
              >
                {{ view.material || '-' }}
              </span>
            </div>

            <div>
              <span class="mb-0.5 block text-[11px] leading-[14px] tracking-[-.01em] text-muted-foreground">{{ 'Fornecedor' | transloco }}</span>
              <span
                class="block text-base font-bold leading-[1.3] text-[#2a2a2a]"
                svcTestId="alert-record-modal__text--supplier"
              >
                {{ view.supplier || '-' }}
              </span>
            </div>

            <div>
              <span class="mb-0.5 block text-[11px] leading-[14px] tracking-[-.01em] text-muted-foreground">{{ 'Hashtag' | transloco }}</span>
              <span
                class="flex flex-wrap items-center gap-2 text-base font-bold leading-[1.3] text-[#2a2a2a]"
                svcTestId="alert-record-modal__text--hashtags"
              >
                @for (hashtag of view.hashtags; track $index) {
                  <span class="rounded-[6px] bg-primary/[.08] px-3 py-[5px] text-[13px] font-semibold leading-none text-primary">{{ hashtag }}</span>
                } @empty {
                  -
                }
              </span>
            </div>
          </div>
        }

        <form
          #recordForm
          class="flex w-full max-w-[420px] flex-col gap-3.5"
          [class.hidden]="isViewMode"
          [formGroup]="formAlert"
        >
          <input
            #inputFile
            type="file"
            multiple
            hidden
            [accept]="acceptFiles"
            (change)="addMediaInputFile($event)"
          />

          <div>
            <label
              class="mb-1.5 block text-xs leading-normal text-[#717182]"
              for="alert-record-modal-opening-date"
            >
              {{ 'Data de abertura' | transloco }} <span class="font-bold text-[#EC221F]" aria-hidden="true">*</span>
            </label>
            <input
              id="alert-record-modal-opening-date"
              class="h-11 w-full rounded-[8px] border border-[#e4e7ea] bg-[#f4f5f7] px-3.5 text-sm leading-[normal] text-[#1c1c1c] opacity-45"
              disabled
              svcTestId="alert-record-modal__input--opening-date-edit"
              [value]="formAlert?.controls.createDate.value | dateFormat"
            />
          </div>

          <div>
            <label
              class="mb-1.5 block text-xs leading-normal text-[#717182]"
              for="alert-record-modal-occurrence-date"
            >
              {{ 'Data de ocorrência' | transloco }} <span class="font-bold text-[#EC221F]" aria-hidden="true">*</span>
            </label>
            <svz-date-picker
              fieldAppearance="design-system"
              formControlName="occurrenceDate"
              inputId="alert-record-modal-occurrence-date"
              svcTestId="alert-record-modal__input--occurrence-date-edit"
              [inputReadOnly]="true"
              [max]="maxOccurrenceDate"
              [dateFilter]="occurrenceDateFilter"
            />
          </div>

          <div>
            <span class="mb-1.5 block text-xs leading-normal text-[#717182]">{{ 'Evidência' | transloco }}</span>
            @if (midiasCarousel?.length) {
              <div class="aspect-[16/10] w-full max-w-[260px] overflow-hidden rounded-[8px] border border-[#f0f2f5] bg-[#EEF1FB]">
                @if (!isInitialLoading) {
                  <svz-media-carousel
                    class="block h-full"
                    fillHeight
                    svcTestId="alert-record-modal__input--evidence"
                    [items]="midiasCarousel"
                    [editMode]="true"
                    [playVideoWhenMouseHover]="false"
                    (onAddTriggered)="carouselAddTrigger = $event; inputFile.click()"
                    (onDeleteTriggered)="removeSlide($event)"
                  />
                }
              </div>
            } @else {
              <div
                class="relative flex size-[104px] items-center justify-center rounded-[8px] border border-[#f0f2f5] bg-[#EEF1FB] text-[#9aa5cf]"
                svcTestId="alert-record-modal__input--evidence"
              >
                <ng-icon
                  name="svcImage"
                  size="20px"
                  aria-hidden="true"
                />
                <button
                  type="button"
                  class="absolute -right-2 -top-2 inline-flex size-6 items-center justify-center rounded-full bg-primary text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                  svcTestId="alert-record-modal__btn--add-evidence"
                  [attr.aria-label]="'Adicionar evidência' | transloco"
                  [zTooltip]="'Adicionar evidência' | transloco"
                  (click)="carouselAddTrigger = null; inputFile.click()"
                >
                  <ng-icon
                    name="svcPlus"
                    size="14px"
                    aria-hidden="true"
                  />
                </button>
              </div>
            }
          </div>

          <div>
            <span class="mb-1.5 block text-xs leading-normal text-[#717182]">{{ 'Originador' | transloco }} <span class="font-bold text-[#EC221F]" aria-hidden="true">*</span></span>
            <span
              class="flex h-11 w-full items-center gap-2 rounded-[8px] border border-[#e4e7ea] bg-[#f4f5f7] px-3.5 text-sm leading-[normal] text-[#1c1c1c]"
              svcTestId="alert-record-modal__text--originator-edit"
            >
              @if (recordView.originator) {
                <svz-user-avatar
                  class="flex-none"
                  [info]="recordView.originator"
                />
                {{ recordView.originator.name }}
              } @else {
                -
              }
            </span>
          </div>

          <div>
            <label
              class="mb-1.5 block text-xs leading-normal text-[#717182]"
              for="alert-record-modal-team"
            >
              {{ 'Time' | transloco }}
            </label>
            <svz-select
              fieldAppearance="design-system"
              formControlName="teamId"
              inputId="alert-record-modal-team"
              svcTestId="alert-record-modal__input--team"
              [label]="null"
              [placeholder]="'Selecione' | transloco"
              [options]="alertCombos?.teams"
              [loading]="isAllCombosLoading"
            />
          </div>

          <div>
            <label
              class="mb-1.5 block text-xs leading-normal text-[#717182]"
              for="alert-record-modal-place"
            >
              {{ 'Local' | transloco }} <span class="font-bold text-[#EC221F]" aria-hidden="true">*</span>
            </label>
            <svz-chip-grouped
              type="single"
              fieldAppearance="design-system"
              formControlName="locationId"
              inputId="alert-record-modal-place"
              svcTestId="alert-record-modal__input--place"
              searchMode="always"
              [label]="null"
              [placeholder]="'Selecione' | transloco"
              [options]="placeOptions"
              [loading]="locationsLoading"
            />
          </div>

          <div>
            <label
              class="mb-1.5 block text-xs leading-normal text-[#717182]"
              for="alert-record-modal-classification"
            >
              {{ 'Classificação' | transloco }} <span class="font-bold text-[#EC221F]" aria-hidden="true">*</span>
            </label>
            <svz-chip
              type="single"
              fieldAppearance="design-system"
              formControlName="classificationId"
              inputId="alert-record-modal-classification"
              svcTestId="alert-record-modal__input--classification"
              [label]="null"
              [placeholder]="'Selecione' | transloco"
              [options]="alertCombos?.classification"
              [loading]="isAllCombosLoading"
            />
          </div>

          <div>
            <label
              class="mb-1.5 block text-xs leading-normal text-[#717182]"
              for="alert-record-modal-failure"
            >
              {{ 'Falha' | transloco }} <span class="font-bold text-[#EC221F]" aria-hidden="true">*</span>
            </label>
            <svz-chip
              type="single"
              fieldAppearance="design-system"
              formControlName="failureId"
              inputId="alert-record-modal-failure"
              svcTestId="alert-record-modal__input--failure"
              [label]="null"
              [placeholder]="'Selecione' | transloco"
              [options]="alertCombos?.failures"
              [loading]="isAllCombosLoading || isSaveLoading || isFailuresLoading"
            />
          </div>

          <div>
            <label
              class="mb-1.5 block text-xs leading-normal text-[#717182]"
              for="alert-record-modal-material-type"
            >
              {{ 'Tipo de material' | transloco }}
            </label>
            <svz-chip
              type="single"
              fieldAppearance="design-system"
              formControlName="materialTypeId"
              inputId="alert-record-modal-material-type"
              svcTestId="alert-record-modal__input--material-type"
              [label]="null"
              [placeholder]="'Selecione' | transloco"
              [options]="alertCombos?.materialType"
              [loading]="isAllCombosLoading"
            />
          </div>

          <div>
            <label
              class="mb-1.5 block text-xs leading-normal text-[#717182]"
              for="alert-record-modal-material"
            >
              {{ 'Material' | transloco }}
            </label>
            <svz-chip
              type="single"
              fieldAppearance="design-system"
              formControlName="productId"
              inputId="alert-record-modal-material"
              svcTestId="alert-record-modal__input--material"
              [label]="null"
              [placeholder]="'Selecione' | transloco"
              [options]="alertCombos?.materials"
              [loading]="isAllCombosLoading || isMaterialsLoading"
            />
          </div>

          <div>
            <label
              class="mb-1.5 block text-xs leading-normal text-[#717182]"
              for="alert-record-modal-supplier"
            >
              {{ 'Fornecedor' | transloco }}
            </label>
            <svz-chip
              type="single"
              fieldAppearance="design-system"
              formControlName="supplierId"
              inputId="alert-record-modal-supplier"
              svcTestId="alert-record-modal__input--supplier"
              [label]="null"
              [placeholder]="'Selecione' | transloco"
              [options]="alertCombos?.suppliers"
              [loading]="isAllCombosLoading"
            />
          </div>

          <div>
            <label
              class="mb-1.5 block text-xs leading-normal text-[#717182]"
              for="alert-record-modal-hashtags"
            >
              {{ 'Hashtag' | transloco }}
            </label>
            <svz-chip-grouped
              type="multiple"
              fieldAppearance="design-system"
              formControlName="hashtagIds"
              inputId="alert-record-modal-hashtags"
              svcTestId="alert-record-modal__input--hashtags"
              [label]="null"
              [placeholder]="'Selecione' | transloco"
              [options]="alertCombos?.hashtags"
              [loading]="isAllCombosLoading"
            />
          </div>
        </form>

        <svc-form-custom-field
          class="mt-3.5 block [&:has(>.grid>*)]:border-t [&:has(>.grid>*)]:border-[#f0f2f5] [&:has(>.grid>*)]:pt-3.5"
          #customField
          [class.alert-record-custom-fields--view]="isViewMode"
          [applicationId]="applicationId"
          [featureId]="featureIdAlert"
          [systemReferenceId]="alertMode?.id"
          [isViewMode]="isViewMode || isSave"
          [onlyCustomFields]="true"
        />

        @if (isViewMode) {
          <div class="mt-3 flex flex-col gap-3">
            <div>
              <span class="mb-0.5 block text-[11px] leading-[14px] tracking-[-.01em] text-muted-foreground">{{ 'Observações' | transloco }}</span>
              <span
                class="block whitespace-pre-line break-words text-base font-bold leading-[1.3] text-[#2a2a2a]"
                svcTestId="alert-record-modal__text--observations"
              >
                {{ recordView.observations || '-' }}
              </span>
            </div>
          </div>

          @if (alert?.alertId) {
            <div class="mt-[5px] flex items-center">
              <div class="inline-flex items-center gap-1">
                <svz-bookmark-button
                  class="inline-flex p-0.5"
                  variant="design-system"
                  iconOutline="svcStar"
                  iconFilled="svcStarFill"
                  iconSizeClass="icon-size-[18px]"
                  svcTestId="alert-record-modal__btn--favorite"
                  [referenceId]="alert?.alertId"
                  [applicationId]="applicationId"
                  [initialValue]="alert?.isBookmarked"
                  (onValueChanged)="onBookmarkChanged($event)"
                />

                <svc-reaction
                  #svcReaction
                  class="hidden"
                  [registryUniqueId]="alert?.alertId"
                  [applicationId]="applicationId"
                  [dontEmitFirstTime]="fromAddMode"
                  (onReactionChange)="onReactionChange($event)"
                  (onLoadingChange)="isReactionLoading = $event"
                />

                <svz-like-button
                  svcTestId="alert-record-modal__btn--like"
                  [liked]="svcReaction.hasReacted"
                  [count]="totalsStatus?.totals?.reactions"
                  [loading]="isReactionLoading"
                  (toggled)="$event ? svcReaction.makeReactionByEnum(likeReaction) : svcReaction.removeCurrentReaction()"
                />

                <button
                  type="button"
                  class="inline-flex h-8 items-center gap-[5px] rounded-[8px] px-2 text-[12.5px] text-muted-foreground hover:bg-muted hover:text-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
                  svcTestId="alert-record-modal__btn--comment"
                  [zTooltip]="'Comentar' | transloco"
                  [attr.aria-label]="'Comentar' | transloco"
                  [disabled]="isSaveLoading"
                  (click)="goToFeed()"
                >
                  <ng-icon
                    name="svcComment"
                    size="15px"
                    aria-hidden="true"
                  />
                </button>
              </div>

              @if (alert?.alertId && alertFeedTab?.alertFeedKey) {
                <svz-totals-status
                  #totalsStatus
                  class="hidden"
                  [referenceId]="alert.alertId"
                  [applicationId]="applicationId"
                  [configTypeId]="alertFeedTab.alertFeedKey"
                  [featureName]="featureName"
                  [available]="{ reactions: true, comments: true, views: true }"
                />
              }

              @if (totalsStatus?.totals?.views) {
                <span
                  class="inline-flex items-center gap-[5px] text-[12.5px] text-muted-foreground"
                  svcTestId="alert-record-modal__text--views"
                  [zTooltip]="totalsStatus.totals.views + ' ' + ((totalsStatus.totals.views === 1 ? 'Visualização' : 'Visualizações') | transloco)"
                  [attr.aria-label]="('Visualizações' | transloco) + ': ' + totalsStatus.totals.views"
                >
                  <ng-icon
                    name="svcEye"
                    size="15px"
                    aria-hidden="true"
                  />
                  {{ totalsStatus.totals.views }}
                </span>
              }
            </div>
          }
        } @else {
          <div
            class="mt-3.5 w-full max-w-[420px]"
            [formGroup]="formAlert"
          >
            <label
              class="mb-1.5 block text-xs leading-normal text-[#717182]"
              for="alert-record-modal-observations"
            >
              {{ 'Observações' | transloco }}
            </label>
            <svc-audio-to-text-wrapper
              class="block w-full overflow-hidden"
              [showVoiceToTextButton]="showVoiceToTextButton"
              [control]="descriptionControl"
            >
              <svz-text-area
                class="block w-full"
                formControlName="description"
                inputId="alert-record-modal-observations"
                svcTestId="alert-record-modal__input--observations"
                [label]="null"
                [placeholder]="'Digite aqui' | transloco"
                [minRows]="5"
                [maxRows]="8"
              />
            </svc-audio-to-text-wrapper>
          </div>
        }
      </div>

      <!-- ACTION PLAN -->
      <div
        *ngIf="showTabActionPlan"
        [class.hidden]="tabIndex !== 1"
        #actionPlanTab
      >
        <app-alert-record-action-plans
          [id]="alertMode?.id"
          [originatorId]="alert?.originatorId || formAlert?.controls?.originatorId?.value"
          [rolesCreatePermission]="rolesCreatePermission"
          [isViewMode]="isViewMode"
          [applicationId]="applicationId"
          [legacyApplicationId]="legacyApplicationId"
          [showSearch]="false"
          [hidePaginationOnSinglePage]="true"
          (openPlans)="openPlans = $event"
          (completePlans)="completePlans = $event"
        />
      </div>

      <!-- FEED -->
      <div
        [class.hidden]="tabIndex !== 2"
        #feedTab
      >
        <app-alert-feed-tab
          #alertFeedTab
          [alertId]="alertMode?.id"
          [isAddMode]="isAddMode"
        />

        @if (!isAddMode && alertFeedTab?.commentsTotal === 0) {
          <div
            class="mt-2 rounded-[12px] border border-[#e4e7ea] px-5 py-12 text-center"
            svcTestId="alert-record-modal__section--feed-empty"
          >
            <h3 class="m-0 mb-1.5 text-base font-bold leading-normal text-[#1c1c1c]">{{ 'Nenhum comentário ainda' | transloco }}</h3>
            <p class="m-0 text-sm leading-normal text-[#5a5f6b]">{{ 'Seja o primeiro a comentar este alerta.' | transloco }}</p>
          </div>
        }
      </div>
    </div>
  </div>

  @if (isInitialLoading) {
    <svc-modal-alert-skeleton />
  }
</div>

@if (!isInitialLoading) {
  <footer class="flex h-16 flex-[0_0_64px] items-center justify-end gap-2.5 bg-primary px-5 max-[640px]:sticky max-[640px]:bottom-0 max-[640px]:z-[2] max-[640px]:h-auto max-[640px]:flex-none max-[640px]:px-4 max-[640px]:pb-[calc(12px+env(safe-area-inset-bottom))] max-[640px]:pt-3 max-[640px]:shadow-[0_-6px_16px_rgba(0,5,36,.25)]">
    @if (isViewMode) {
      <button
        type="button"
        class="flex h-[30px] w-[30px] items-center justify-center rounded-[6px] text-white hover:bg-white/[.18] focus-visible:outline focus-visible:outline-2 focus-visible:outline-white disabled:opacity-50 max-[640px]:mr-auto max-[640px]:w-10 max-[640px]:flex-[0_0_40px]"
        z-dropdown
        svcTestId="alert-record-modal__icon-btn--more-options"
        [zDropdownMenu]="moreOptionsMenu"
        zPlacement="above"
        [attr.aria-label]="'Mais opções' | transloco"
        [disabled]="isSaveLoading"
      >
        <ng-icon
          name="svcKebab"
          size="18px"
          aria-hidden="true"
        />
      </button>

      <z-dropdown-menu-content
        #moreOptionsMenu="zDropdownMenuContent"
        class="w-[210px] min-w-0 rounded-[12px] border border-[#e4e7ea] bg-white p-1.5 shadow-[0_10px_30px_rgba(0,0,0,.18)]"
      >
        <button
          type="button"
          z-dropdown-menu-item
          class="h-8 gap-2 rounded-[7px] px-2.5 py-2 text-sm leading-[normal] text-[#1c1c1c] hover:bg-muted focus:bg-muted data-highlighted:bg-muted [&_svg]:size-4"
          svcTestId="alert-record-modal__menu--print"
          (click)="print()"
        >
          <ng-icon
            name="svcPrinter"
            size="16px"
            aria-hidden="true"
          />
          <span>{{ 'Imprimir' | transloco }}</span>
        </button>

        @if (userLoggedId === alert?.originatorId || userHasPermissionToDelete) {
          <div
            class="mx-2 my-1 h-px bg-[#e4e7ea]"
            role="separator"
          ></div>

          <button
            type="button"
            z-dropdown-menu-item
            class="h-8 gap-2 rounded-[7px] px-2.5 py-2 text-sm leading-[normal] text-[#1c1c1c] hover:bg-muted focus:bg-muted data-highlighted:bg-muted [&_svg]:size-4"
            svcTestId="alert-record-modal__menu--delete"
            (click)="confirmDeletion(alert?.alertUniqueId)"
          >
            <ng-icon
              name="svcTrash"
              size="16px"
              aria-hidden="true"
            />
            <span>{{ 'Excluir alerta' | transloco }}</span>
          </button>
        }
      </z-dropdown-menu-content>
    }

    <button
      type="button"
      class="inline-flex h-10 items-center justify-center whitespace-nowrap rounded-[8px] border border-white bg-transparent px-4 text-sm leading-[normal] font-semibold text-white hover:bg-white/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white max-[640px]:h-11 max-[640px]:flex-1"
      id="svc-modal-alert-button-close"
      svcTestId="alert-record-modal__btn--secondary"
      (click)="dialogRef.close()"
    >
      {{ (isViewMode ? 'Fechar' : 'Cancelar') | transloco }}
    </button>

    @if (isAddMode) {
      <button
        type="button"
        class="inline-flex h-10 items-center justify-center whitespace-nowrap rounded-[8px] border border-white bg-white px-4 text-sm leading-[normal] font-semibold text-primary hover:bg-[#f1f3fb] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white disabled:pointer-events-none disabled:opacity-50 max-[640px]:h-11 max-[640px]:flex-1"
        id="svc-modal-alert-button-add"
        svcTestId="alert-record-modal__btn--include"
        [disabled]="isSaveLoading"
        (click)="createOrUpdateAlert()"
      >
        {{ 'Incluir' | transloco }}
      </button>
    } @else if (userLoggedId === alert?.originatorId || userHasPermissionToEdit) {
      <button
        type="button"
        class="inline-flex h-10 items-center justify-center whitespace-nowrap rounded-[8px] border border-white bg-white px-4 text-sm leading-[normal] font-semibold text-primary hover:bg-[#f1f3fb] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white disabled:pointer-events-none disabled:opacity-50 max-[640px]:h-11 max-[640px]:flex-1"
        id="svc-modal-alert-button-edit"
        svcTestId="alert-record-modal__btn--edit"
        [disabled]="isSaveLoading"
        (click)="setEditMode()"
      >
        {{ (isViewMode ? 'Editar' : 'Salvar') | transloco }}
      </button>
    }
  </footer>
}
